import React, { useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { Router, Route, Switch, withRouter } from "react-router-dom";
import history from "./history";

import { PrivateRoute } from "./components/layout";
import { MainLayout } from "./components/layout";
import PageSpinner from "./components/common/PageSpinner";
// import Test from "./pages/test/Test";

// Admin dashboard.=========================================
import { AdminDashboard } from "./pages/adminDashboard/index";
import ForgotPassword from './pages/loginRegister/ForgotPassword';
// Admin settings.=========================================
import {
  CompanyLocation,
  Department,
  Designation,
  WorkPrimise,
  EmployeeType,
  Reward,
  LeaveType,
  HolidayCalender,
  CompanyPolicy,
  RolesNdPermissions,
  Assets,
  SkillCategory,
  Skills,
  Certifications,
  Technologies,
  Questionsforappraisee,
  ReviewRatingforApprisal,
  BehavioralAttributeforApprisal,
  Potential,
  PrimaryGoals,
  AssignLeave,
  ConfigureMail,
  ConfigureMailForLeave,
  YearEndProcess,
  AutoLOPConfig,
  AutoLOPWarningConfig,
  TimesheetAutoLockConfig,
  WeeklyTimesheetReminderConfig,
} from "./pages/adminSettings/index";
// Employee.=========================================
import {
  EmployeeDashboard,
  EmployeeSettings,
  EmployeeProfileView,
  EmployeeRewards,
  AssignRewards,
  ProcessRewards,
  EmployeeAppraisal,
  TaskSheetUnlockStatus,
  EmployeeExcelImport,
  AssetExcelImport,
  calendaryear,
  Shifts,
  MyLeave,
  MyAppliedLeaveList,
  LeaveApplicationList,
  ApplyMyLeaves,
  MyLeaveList,
  MyLeaveAppliedList,
  MyProcessLeaveList,
  HolidayCalendarList,
  LeaveCalendar,
  MyDutyAppliedList
} from "./pages/employee/index";
// Projects.=========================================
import { ListProjects, ViewProject } from "./pages/projects/index";
// Tasks.=========================================
import { TaskManagment, TaskBoard,ViewTaskManagment,ModernViewTaskManagement,ViewWorkSummary,ReportSummary,LeaveSummaryList } from "./pages/tasks/index";
// payroll.=========================================
import {
  EmployeeSalary,
  PayRollItems,
  SalaryProcess,
  SalaryReport,
  PLReport,
} from "./pages/payroll/index";
// Finance.=========================================
import { PettyCash, Invoice, GiftVoucher } from "./pages/finance/index";
//  Helpdesk Tickects.==============================
import {
  HelpDeskTickets,
  TicketDetails,
  ListAllTicktes,
  AdminListAllTickets,
  TaskUnlock,
  HelpDeskSettings,
  ListAllAssignedTicktes
} from "./pages/helpDeskTickets";
import {ExpandedTaskView,
  AllTaskCalender
} from "./components/tasks"
// Login.====================================
import { Login } from "./pages/loginRegister";
import Test from "./pages/test/Test";
import EmployeeAppraisalHome from "./pages/employee/appraisal/EmployeeAppraisalHome";
import PreviousPerformanceGoals from "./pages/employee/appraisal/PreviousPerformanceGoals";
import { useAppraisalAssign } from "./components/adminSettings";
import AppraisalAssign from "./components/adminSettings/appraisal/AppraisalAssign";
// 🧠 Global invalid date tracker
window.addEventListener("error", (e) => {
  if (e.message.includes("Invalid time value")) {
    console.error("🔥 Invalid date somewhere:", e);
    console.log("🔍 Stack trace:", e.error?.stack);
  }
});

const ViewPreviousProject = React.lazy(() =>
  import("./components/employee/previousProjects/ViewPreviousProject.js")
);

function App() {
  useEffect(() => {
    if (window.location.pathname === "/") {
      window.location.href = "/em";
      // return <Redirect to="/em"></Redirect>;
    }
    if (window.location.pathname === "/empAppraisalHome") {
      let review = JSON.parse(window.sessionStorage.getItem("isReview"));
      window.location.href = "/empAppraisal";
      // return <Redirect to="/em"></Redirect>;
    }
  }, []);
  return (
  <AuthProvider>
      <Router history={history}>
        <Switch>
    
        <Route exact path="/em" component={Login} />
         <Route exact path="/forgot-password" component={ForgotPassword} />

        <MainLayout>
          <React.Suspense fallback={<PageSpinner />}>
            {/* home routes */}

            <PrivateRoute
              exact
              path="/adminDashboard"
              component={AdminDashboard}
            ></PrivateRoute>
            {/* ----------Admin Settings Routes----------------- */}
            <Route exact path="/department" component={Department}></Route>
            <Route exact path="/designation" component={Designation}></Route>
            <Route exact path="/workprimise" component={WorkPrimise}></Route>
            <Route exact path="/reward" component={Reward}></Route>
            <Route exact path="/leavetype" component={LeaveType}></Route>
            <Route exact path="/yearendprocess" component={YearEndProcess}></Route>
            
            <Route exact path="/assets" component={Assets}></Route>
            <Route exact path= "/primarygoals" component={PrimaryGoals}></Route>
            <Route exact path="/questionsforappraisee" component={Questionsforappraisee}></Route>
            <Route exact path="/reviewrating" component={ReviewRatingforApprisal}></Route>
            <Route exact path="/attribute" component={BehavioralAttributeforApprisal}></Route>
            <Route exact path="/potential" component={Potential}></Route>
              
            <Route
              exact
              path="/companylocation"
              component={CompanyLocation}
            ></Route>
            <Route
              exact
              path="/employeetype"
              component={EmployeeType}
            ></Route>
          
             <Route
              exact
              path="/shifts"
              component={Shifts}
            ></Route>
             <Route
              exact
              path="/assignleave"
              component={AssignLeave}
            ></Route>
            <Route exact path="/configuremail" component={ConfigureMail}></Route>
            <Route exact path="/configuremailforleave" component={ConfigureMailForLeave}></Route>
            <Route exact path="/autolopconfig" component={AutoLOPConfig}></Route>
            <Route exact path="/autolopwarningconfig" component={AutoLOPWarningConfig}></Route>
            <Route exact path="/timesheetautolockconfig" component={TimesheetAutoLockConfig}></Route>
            <Route exact path="/weeklytimesheetreminderconfig" component={WeeklyTimesheetReminderConfig}></Route>
            <Route
              exact
              path="/companypolicy"
              component={CompanyPolicy}
            ></Route>
            <Route
              exact
              path="/rolesndpermission"
              component={RolesNdPermissions}
            ></Route>
             <Route
              exact
              path="/skillcategory"
              component={SkillCategory}
            ></Route>
             <Route
              exact
              path="/skills"
              component={Skills}
            ></Route>
            <Route
              exact
              path="/certifications"
              component={Certifications}
            ></Route>
             <Route
              exact
              path="/technologies"
              component={Technologies}
            ></Route>
             <Route
              exact
              path="/tasksheetUnlock"
              component={TaskUnlock}
            ></Route>
            
            {/* ----------Employee Settings Routes-----------------  */}
            <PrivateRoute
              exact
              path="/employeeDashboard"
              component={withRouter(EmployeeDashboard)}
            ></PrivateRoute>
            <Route exact path="/emplist" component={withRouter(EmployeeSettings)} />
            <Route
              exact
              path="/empProfile/:empId"
              component={EmployeeProfileView}
            />
            <Route
              exact
              path="/appraisal"
              component={AppraisalAssign}
            />
            <Route
              exact
              path="/empAppraisal"
              component={EmployeeAppraisalHome}
            />
             <Route
              exact
              path="/empAppraisalHome"
              component={EmployeeAppraisal}
            />
             <Route
              exact
              path="/previousPerformanceGoals"
              component={PreviousPerformanceGoals}
            />
            <Route
              exact
              path="/empRewards/:empId"
              component={EmployeeRewards}
            />
            <Route
              exact
              path="/assignRewards"
              component={AssignRewards}
            ></Route>
          
            
            <Route
              exact
              path="/processRewards"
              component={ProcessRewards}
            ></Route>
              <Route
              exact
              path="/employeeexcelimport"
              component={EmployeeExcelImport}
            ></Route> 
           <Route
              exact
              path="/assetexcelimport"
              component={AssetExcelImport}
            ></Route>
            <Route exact path="/listProjects" component={ListProjects} />
            <Route
              exact
              path="/viewProject/:projectId"
              component={ViewProject}
            />
            {/* Task ------------------------------------------------- */}
            <Route exact path="/taskManagment" component={TaskManagment} />
            {/* <Route exact path="/viewtaskManagment" component={ViewTaskManagment} /> */}
            <Route exact path="/modernViewTaskManagement" component={ModernViewTaskManagement} />
            <Route exact path="/ReportSummary" component={ReportSummary} />
            <Route exact path="/LeaveSummaryList" component={LeaveSummaryList} />
            <Route exact path="/viewworkSummary" component={ViewWorkSummary} />
            <Route exact path="/MyLeave" component={MyLeave} />
            <Route exact path="/ApplyMyLeaves" component={ApplyMyLeaves} />
            {/* <Route exact path="/DutyApplicationList" component={DutyApplicationList} /> */}
            <Route exact path="/MyLeaveList" component={MyLeaveList} />
             <Route exact path="/MyProcessLeaveList" component={MyProcessLeaveList} />
            <Route exact path="/HolidayCalendarList" component={HolidayCalendarList} />
            <Route exact path="/LeaveCalendar" component={LeaveCalendar} />
            {/* <Route exact path="/DutyApplicationList" component={DutyApplicationList} /> */}
            <Route exact path="/LeaveApplicationList" component={LeaveApplicationList} />
            <Route exact path="/MyAppliedLeaveList" component={MyLeaveAppliedList} />
            <Route exact path="/MyLeaveAppliedList" component={MyLeaveAppliedList} />
            <Route exact path="/MyDutyAppliedList" component={MyDutyAppliedList} />
            <Route
              exact
              path="/taskboard/:projectId"
              component={TaskBoard}
            />

            <Route
              exact
              path="/viewPreviousProject/:workExperienceId/:employeeId"
              component={ViewPreviousProject}
            ></Route>
            {/* Leave Management */}
            <Route exact path="/calendaryear" component={calendaryear} />
            <Route
              exact
              path="/holidaycalender"
              component={HolidayCalender}
            ></Route>
            {/* payroll -----------------------------------------------  */}
            <Route exact path="/employeeSalary" component={EmployeeSalary} />
            <Route exact path="/payRollItems" component={PayRollItems} />
            <Route exact path="/processSalary" component={SalaryProcess} />
            <Route exact path="/salaryReport" component={SalaryReport} />
            <Route exact path="/plReport" component={PLReport} />
            {/* finance -----------------------------------------------  */}
            <Route exact path="/pettyCash" component={PettyCash} />
            <Route exact path="/giftVoucher" component={GiftVoucher} />
            <Route exact path="/invoice" component={Invoice} />

            {/* helpdesk tickets ----------------------------------------------- HelpDeskSettings */}
            <Route exact path="/HelpDeskSettings" component={HelpDeskSettings} />
            <Route exact path="/helpdesk" component={HelpDeskTickets} />
            <Route
              exact
              path="/ticketDetails/:ticketId"
              component={TicketDetails}
            />
            <Route exact path="/ListAllTicktes" component={ListAllTicktes} />
            <Route exact path="/ListAllAssignedTicktes" component={ListAllAssignedTicktes} />
            <Route
              exact
              path="/adminListAllTickets"
              component={AdminListAllTickets}
            />
            <Route
            exact path={"/taskSheetUnlockStatus"}
            component={TaskSheetUnlockStatus}
            />
            <Route exact path="/test" component={Test} />
             <Route exact path="/all-task-calendar" component={AllTaskCalender} />
             <Route path="/all-task-calendar-expanded" component={ExpandedTaskView} />
          </React.Suspense>
        </MainLayout>
        {/* login -----------------------------------------------  */}
  
  
 </Switch>
      </Router>
    </AuthProvider>
  );
}

export default App;
